import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "./style-guide.css";
import "./common.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);